// Routes getters

import APP_ROUTES from "./routeConstants";

type Id = string | number;

// Profiles
export const getEntityProfileRoute = (entityId: Id) => `/entity/${entityId}`;
export const getPlayerProfileRoute = (userId: Id) => `/player/${userId}`;
export const getCoachProfileRoute = (userId: Id) => `/coach/${userId}`;
export const getAgentProfileRoute = (userId: Id) => `/agent/${userId}`;
export const getScoutProfileRoute = (userId: Id) => `/scout/${userId}`;
export const getOtherProfileRoute = (userId: Id) => `/other/${userId}`;

// Events
export const getEventRoute = (eventId: Id) => `/events/${eventId}`;
export const getCreateEventTypeRoute = (eventType: string) => `/events/create/${eventType}`;

// Groups
export const getGroupRoute = (groupId: Id) => `/entity/group/${groupId}`;

// Search
export const getSearchValueRoute = (value: string) => `/search?value=${value}`;
export const getSearchTypeUserValueRoute = (value: string) => `/search?type=users&value=${value}`;
export const getSearchTypeEntityValueRoute = (value: string) => `/search?type=entities&value=${value}`;

// Chat
export const getChatThreadRoute = (threadId?: string, selectedReceiverId?: number) =>
  `/chat/${threadId}/${selectedReceiverId}`;

// GoStar
export const getGoStarRoute = (query?: string) => `/go-star/${query ?? query}`;

export const normalizePath = (path: string) => path.replace(/\/+$/, "");

export const isCurrentRoute = (currentPath: string, targetPath: string) =>
  normalizePath(currentPath) === normalizePath(targetPath);

// global navigate function to be used within interceptors
let navigate: (path: string) => void;

export const setNavigate = (navFn: (path: string) => void) => (navigate = navFn);

export const navigateTo = (path: string) => {
  if (navigate) navigate(path);
};

// Network
export const getNetworkRoute = (tab?: "following" | "followers") => `${APP_ROUTES.NETWORK}${tab && `?tab=${tab}`}`;
